import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useHopperConfigs} from '../api/hooks';
import {useAuth} from '../context/useAuth';
import {useUiStore} from '../store/uiStore';
import {SubmissionsWorkspace} from '../components/submissions/SubmissionsWorkspace';

export function SubmissionsPage() {
  const [searchParameters] = useSearchParams();
  const {user} = useAuth();
  const hasBroadView = user?.role === 'analyst_admin' || user?.role === 'admin';
  const submissionScope = useUiStore((s) => s.submissionScope);
  const setSubmissionScope = useUiStore((s) => s.setSubmissionScope);

  // A dashboard hopper tile's count is org-wide (useSubmissionStats(true) - see DashboardPage), so
  // landing here from one with the analyst's own persisted "Mine" scope would show a filtered list
  // that doesn't match the count that was just clicked. Session-only (never written to the
  // persisted uiStore) so it doesn't silently flip the analyst's saved preference for next time -
  // it's cleared the moment they touch the toggle themselves. Only for a policy_violation param
  // present on arrival (i.e. from a hopper tile): the vertical tabs write the same param, and
  // picking one must not flip the scope. BroadView users already see everyone.
  const [hopperViewAllOverride, setHopperViewAllOverride] = useState(() =>
    Boolean(searchParameters.get('policy_violation'))
  );

  const hoppers = useHopperConfigs();
  const p0For = searchParameters.get('p0For');
  const focusSubmission = searchParameters.get('submission');

  return (
    <SubmissionsWorkspace
      hopperConfigs={hoppers.data ?? []}
      {...(p0For ? {autoOpenP0ForSubmissionId: p0For} : {})}
      {...(focusSubmission ? {focusSubmissionId: focusSubmission} : {})}
      hasBroadView={hasBroadView}
      scope={hopperViewAllOverride && !hasBroadView ? 'all' : submissionScope}
      onScopeChange={(next) => {
        setHopperViewAllOverride(false);
        setSubmissionScope(next);
      }}
    />
  );
}
